"use client";

import React from "react";
var __jsx = React.createElement;
import { Button } from "./ui/button";
import AwesomeIcon from "../../AwesomeIcon";
import { faTimes, faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
export function DeleteConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    title = _ref.title;
  if (!isOpen) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center p-4",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-black/50 dark:bg-black/70"
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative bg-white dark:bg-gray-900 rounded-lg shadow-lg max-w-md w-full overflow-hidden",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-semibold text-gray-900 dark:text-white flex items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationTriangle,
    size: "lg",
    className: "text-red-500 mr-3"
  }), "Confirm Deletion"), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    onClick: onClose,
    className: "h-8 w-8 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTimes,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-700 dark:text-gray-300 mb-4"
  }, "Are you sure you want to delete this recording?", /*#__PURE__*/React.createElement("span", {
    className: "block mt-2 font-medium text-gray-900 dark:text-white"
  }, title)), /*#__PURE__*/React.createElement("p", {
    className: "text-md text-gray-500 dark:text-gray-400 mb-4"
  }, "This action cannot be undone."), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end space-x-3"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    onClick: onClose,
    className: "border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "destructive",
    onClick: onConfirm,
    className: "bg-red-600 hover:bg-red-700 text-white"
  }, "Delete")))));
}